import EventWallThemeStyles from './event-wall-theme-styles';
import EventFormThemeStyles from './event-form-theme-styles';

export default {
    ...EventWallThemeStyles,
    ...EventFormThemeStyles
};
